export default __webpack_public_path__ + "static/media/skyScrapers.8f220e3d.png";